// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar_Zmt7v {
    justify-content: space-between !important;
    align-items: center !important;
}

.toolbars_v16lS {
  min-height: 58px;
}

.content_zzd9w {
    width: 100%;
    height: 100%;
}

.selected_GefBU.win_WJRqJ.really_f63Bs {
    background-color: var( --color-tableSelected ) !important;
  }
  
  .rollover_MQBht.win_WJRqJ.really_f63Bs {
    background-color: var( --color-tableRollover ) !important;
    cursor: pointer;
  }
  .selected_GefBU.rollover_MQBht.win_WJRqJ.really_f63Bs {
    background-color: var( --color-tableRolloverSelected ) !important;
  }`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/dataViewers/table/TableContentView.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;IACzC,8BAA8B;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yDAAyD;EAC3D;;EAEA;IACE,yDAAyD;IACzD,eAAe;EACjB;EACA;IACE,iEAAiE;EACnE","sourcesContent":[".toolbar {\n    justify-content: space-between !important;\n    align-items: center !important;\n}\n\n.toolbars {\n  min-height: 58px;\n}\n\n.content {\n    width: 100%;\n    height: 100%;\n}\n\n.selected.win.really {\n    background-color: var( --color-tableSelected ) !important;\n  }\n  \n  .rollover.win.really {\n    background-color: var( --color-tableRollover ) !important;\n    cursor: pointer;\n  }\n  .selected.rollover.win.really {\n    background-color: var( --color-tableRolloverSelected ) !important;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolbar": `toolbar_Zmt7v`,
	"toolbars": `toolbars_v16lS`,
	"content": `content_zzd9w`,
	"selected": `selected_GefBU`,
	"win": `win_WJRqJ`,
	"really": `really_f63Bs`,
	"rollover": `rollover_MQBht`
};
export default ___CSS_LOADER_EXPORT___;
